import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MetaService } from '@bo-client/core/api/meta-service';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { FeederContractModel } from '../model/feeder-contract.model';

@Component({
  selector: 'app-fc-change-state',
  templateUrl: './fc-change-state.component.html',
  styleUrls: []
})
export class FcChangeStateComponent
  implements
    CustomFormComponent<
      FeederContractModel,
      {
        additionalData: string;
        comment: string;
      }
    >,
    OnInit
{
  @Input() data: DataForCustomFormModel<FeederContractModel>;
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();

  public model: FeederContractModel;
  public currentForm: FormGroup;
  public comment = '';

  constructor(private fb: FormBuilder, public metaService: MetaService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.fb.group({
      newState: [this.data.model.state, [Validators.required]],
      comment: [null, [Validators.required]]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    this.onConfirm.emit({
      additionalData: this.currentForm.get('newState').value,
      comment: this.currentForm.get('comment').value
    });
  }
}
